document.addEventListener('DOMContentLoaded', function(){
  
  	let thumbContainer = document.querySelector('.pm-thumb-container');
  	if(!thumbContainer) return;
  
  	let divToAppend = null;
  	
	let productSliderDots = document.querySelectorAll(".product__media.flickity-enabled .flickity-page-dots li.dot");
    if(!productSliderDots) return;
  
  	productSliderDots.forEach(function (dot, i) {
      divToAppend = document.querySelector(`.pm-thumb[data-flick-index="${i}"]`);
      if(divToAppend) dot.innerHTML = divToAppend.outerHTML;
    });
  
  	document.querySelectorAll('.pm-thumb').forEach(function (dot, i) {
      dot.addEventListener('click', e => e.currentTarget.parentElement && e.currentTarget.parentElement.click())
    });
})